import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * organizationActionCreators
 */
import entityActionFactory from './factories/entityActionFactory';
import detailActionFactory from './factories/detailActionFactory';
import changeActionFactory from './factories/changeActionFactory';
const detailActions = detailActionFactory('organization', 'organizations');
const entityActions = entityActionFactory('organization', 'organizations');
const changeActions = changeActionFactory('organization', 'organizations');
const createCoatingScoreDivisions = (orgID, userID, csdIDs, coatingScores, createdDate) => coatingScores.map((score, index) => _objectSpread(_objectSpread({}, score), {}, {
  id: csdIDs[index],
  // set a new ID for a unique row on CoatingScoreDivision table
  appCreatorID: userID,
  appCreated: createdDate,
  organizationID: orgID
}));

/**
 * Create an organization.
 */
const create = (orgID, userID) => {
  const defaultData = {
    id: orgID,
    appCreatorID: userID,
    coatingScoreDivisions: [] // default values are set in `Organization` component
  };

  // note this is calling the original changeActions.create
  return changeActions.create(orgID, defaultData);
};
const setDefaultCoatingScoreDivisions = (orgID, userID, csdIDs, coatingScores, createdDate) => {
  const coatingScoreDivisions = createCoatingScoreDivisions(orgID, userID, csdIDs, coatingScores, createdDate);
  return changeActions.changeQuietly(orgID, 'coatingScoreDivisions', coatingScoreDivisions);
};
const organizationActions = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entityActions), detailActions), changeActions), {}, {
  create,
  setDefaultCoatingScoreDivisions
});
export default organizationActions;